<template>
  <div class="opple-ota-bind">
    <div class="opple-ota-cards_progress">
      <div class="opple-ota-cards_progress_btn">
        <OppleAuth
          v-if="status.isShowStartBtn "
          code="OTADevice"
          inline
        >
          <OppleButton
            size="mini"
            :disabled="disabledBoot || status.isStartDisabled"
            :loading="isLoadingReqOta"
            @click="startOta"
          >
            {{ $t('deviceMsg.uplevel') }}
          </OppleButton>
        </OppleAuth>
        <OppleAuth
          v-if="status.isShowCancelBtn"
          code="OTADevice"
          inline
        >
          <OppleButton
            size="mini"
            type="default"
            :loading="isLoadingReqCancelOta"
            @click="onRequestCancelOta"
          >
            {{ $t('sync.close') }}
          </OppleButton>
        </OppleAuth>
      </div>
      <p class="opple-ota-cards_progress_info" :style="{ color: infoColor }">
        {{ otaInfo }}
      </p>
      <OtaProgress :progress="progress" :ota-status="otaStatus" />
    </div>
    <div
      v-if="versionList.length"
      class="opple-ota-bind_cards"
    >
      <div
        v-for="(item, index) in versionList"
        :key="`${item.SourceType || 0}-${index}`"
        class="opple-ota-card"
      >
        <div class="opple-ota-card_head">
          <span>{{ getCardHeadText(item) }}</span>
        </div>
        <div class="opple-ota-card_main">
          <ul>
            <li v-if="isMultiFirmware">
              {{ $t('deviceMsg.firmwareNo') }}: <span>{{ item.SourceType || 0 }}</span>
            </li>
            <li>
              {{ $t('deviceMsg.currentversion') }}:
              <span>{{ item.LocalVersion }}</span>
            </li>
            <li>
              {{ $t('deviceMsg.newversion') }}: <span>{{ item.LatestedVersion }}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { OTA_STATUS_ENUMS } from './enums';
import OtaProgress from './OtaProgress';
import OppleButton from '@/components/Base/OppleButton/index.vue'
import { alerterror, success, warning, error } from '@/assets/js/common.js'
import {
  BatchStartCombineOta,
  StopOta
} from '@/axios/IDevice.js';
import { postWebIOSocket } from '@assets/socket'
import sleep from '@utils/sleep'
import { searchOTAListOptimize } from '@/axios/IOtaTask.js';
import { OTAUpgradeType } from '@/enums/device'

export default {
  components: { 
    OtaProgress,
    OppleButton
  },
  props: {
    versionList: {
      type: Array,
      default: () => {
        return []
      }
    },

    deviceModel: {
      type: Object,
      default: () => ({})
    },

    /** 固件接口 OtaUpgradeTypeList，用于判断是否支持 SIGMESH 合并升 */
    otaUpgradeTypeList: {
      type: Array,
      default: () => []
    },

    isDisabledGuide: {
      type: Boolean,
      default: false
    },

    customColor: {
      type: String,
      default: ''
    },
    // hasError: {
    //   type: Boolean,
    //   default: false
    // }
  },

  data() {
    return {
      disabledBoot: false,
      isLoadingReqOta: false,
      isLoadingReqCancelOta: false,
      hasError: false,
      otaStatus: OTA_STATUS_ENUMS.PADDING,
      progress: 0,
      otaInfo: '',
      bindInfo: {},
      otaSuccessHandled: false,
      otaStopHandled: false,
      removeSocketTimer: null,
    }
  },
  
  computed: {
    infoColor() {
      return this.hasError ? 'red' : '';
    },

    status() {
      if (this.bindInfo.LatestedVersion === '-') {
        return {
          // text,
          isShowStartBtn: false,
          isStartDisabled: false,
          isShowCancelBtn: false
        }
      }

      // 单固件还是多固件
      // if (this.type === 0) {
      //   return {
      //     // text,
      //     isShowStartBtn: false,
      //     isStartDisabled: true,
      //     isShowCancelBtn: false
      //   }
      // }

      // 已经是最新的
      if (this.bindInfo.isLasted) {
        return {
          // text,
          isShowStartBtn: false, // 有一个升级就都不展示
          isStartDisabled: true,
          isShowCancelBtn: false
        }
      }

      // 非最新
      // 在线可升级
      if (!this.deviceModel.IsOnline) {
        return {
          // text, // this.$t('otaUpdate.offline'), // this.$t('deviceMsg.uptodate')
          isShowStartBtn: false,
          isStartDisabled: false,
          isShowCancelBtn: false
        }
      };

      const isShowStartBtn = [
        OTA_STATUS_ENUMS.PADDING, 
        OTA_STATUS_ENUMS.STOP, 
        // OTA_STATUS_ENUMS.UPDATE_FAILED
      ].includes(this.otaStatus);

      // const isShowCancelBtn = [
      //   OTA_STATUS_ENUMS.PROCESSING,
      // ].includes(this.otaStatus);
      
      const isShowCancelBtn = this.otaStatus === OTA_STATUS_ENUMS.PROCESSING;

      return {
        // text,
        isShowStartBtn,
        isStartDisabled: this.isDisabledGuide,
        isShowCancelBtn
      }
    },
    socketmodel() {
      return this.$store.state.socketmodel //需要监听的数据
    },

    isMultiFirmware() {
      return this.versionList.length > 1
    },
  },

  watch: {
    versionList: {
      immediate: true,
      handler(val) {
        const list = Array.isArray(val) ? val : []
        const isLasted = list.length > 0 && list.every(item => item.isLasted === true)
        const LatestedVersion = list.length > 0 && list.every(item => item.LatestedVersion === '-')
          ? '-'
          : (list[0]?.LatestedVersion || '')

        this.bindInfo = {
          isLasted,
          LatestedVersion
        }
      }
    },

    socketmodel (res) {
      this.handlerSocket(res);
    },
  },

  beforeDestroy() {
    this.clearRemoveSocketTimer();
  },

  created() {
   
  },

  mounted() {},

  methods: {
    getCardHeadText(item) {
      if (item.LatestedVersion === '-') {
        return `${this.$t('otatask.firmware')}${(item.SourceType || 0)}`
      }

      if (item.isLasted) {
        return this.$t('deviceMsg.uptodate')
      }

      return this.$t('deviceMsg.canUpgradeingMaster')
    },

    // normalizeClassSku(classSku) {
    //   const raw = String(classSku || '').trim().toLowerCase();

    //   if (!raw) return '';

    //   return raw.startsWith('0x') ? raw : `0x${raw}`;
    // },

    getGatewayVDeviceId() {
      const { deviceModel } = this;

      // if (Number(deviceModel.ChildCategoryType) === 1) {
      //   return String(deviceModel.VDeviceId);
      // }

      return deviceModel.GatewayVDeviceId
    },

    findGatewayNode(otaDeviceList) {
      const gatewayId = this.getGatewayVDeviceId();

      return (otaDeviceList || []).find(item => item.GatewayVDeviceId === gatewayId);
    },

    findSubListDevices(gatewayNode, classSku) {
      const subList = gatewayNode?.SubList || {};
      const normalizedSku = this.normalizeClassSku(classSku);
      const matchedKey = Object.keys(subList).find(key =>
        this.normalizeClassSku(key) === normalizedSku
      );

      return matchedKey ? subList[matchedKey] : [];
    },

    getUpgradableOtaItems(otaVersionList) {
      return (otaVersionList || [])
        .filter(item =>
          item.LocalVersion !== item.LatestedVersion &&
          item.LatestedVersion !== '-' &&
          item.LatestedVersion != null
        )
        .map(item => ({
          SourceType: item.SourceType,
          Version: item.LatestedVersion
        }));
    },

    /** 一级设备：ParentVDeviceId === VDeviceId */
    isPrimaryDevice(device = this.deviceModel) {
      return Number(device?.ParentVDeviceId) === Number(device?.VDeviceId);
    },

    /** 固件升级方式是否支持 SigMesh OTA */
    supportsSigMeshOta() {
      return (this.otaUpgradeTypeList || []).some(item => {
        const supportType = Number(item.SupportType) || 0;
        return (supportType & OTAUpgradeType.SIGMESH_OTA) === OTAUpgradeType.SIGMESH_OTA;
      });
    },

    /** 非一级 + 支持 SIGMESH → 全量合并；否则只升自己 */
    shouldCombineUpgrade() {
      return !this.isPrimaryDevice() && this.supportsSigMeshOta();
    },

    /** 只升自己：从 searchOTAListOptimize 结果中找本机 */
    findSelfDeviceInOtaList(otaDeviceList) {
      const list = Array.isArray(otaDeviceList) ? otaDeviceList : [];
      const vDeviceId = Number(this.deviceModel.VDeviceId);

      // 一级设备：顶层每项即设备本体，不进 SubList
      if (this.isPrimaryDevice()) {
        return list.find(item => Number(item.VDeviceId) === vDeviceId) || null;
      }

      // 子设备：同网关 SubList[ClassSku] 中找自己
      const gatewayNode = this.findGatewayNode(list);

      if (!gatewayNode) return null;

      const sameSkuList = (gatewayNode.SubList || {})[this.deviceModel.ClassSku] || [];

      return sameSkuList.find(device => Number(device.VDeviceId) === vDeviceId) || null;
    },

    buildSelfOtaInfoMapping(otaDeviceList) {
      const mapping = {};
      const self = this.findSelfDeviceInOtaList(otaDeviceList);

      if (!self?.IsOnline) return mapping;

      const otaItems = this.getUpgradableOtaItems(self.OtaVersionList);

      if (otaItems.length) {
        mapping[this.deviceModel.VDeviceId] = otaItems;
      }

      return mapping;
    },

    buildDeviceOtaInfoMapping(otaDeviceList) {
      if (!this.shouldCombineUpgrade()) {
        return this.buildSelfOtaInfoMapping(otaDeviceList);
      }

      const gatewayNode = this.findGatewayNode(otaDeviceList);

      if (!gatewayNode) return {};

      const deviceOtaInfoMapping = {};
      const arr = (gatewayNode.SubList || {})[this.deviceModel.ClassSku] || [];

      arr.forEach(device => {
        if (!device.IsOnline) return;
        // 合并升排除一级设备
        if (this.isPrimaryDevice(device)) return;

        const otaItems = this.getUpgradableOtaItems(device.OtaVersionList);

        if (!otaItems.length) return;

        deviceOtaInfoMapping[device.VDeviceId] = otaItems;
      });

      return deviceOtaInfoMapping;
    },

    async findAllUpgradeDevices() {
      const res = await searchOTAListOptimize({
        DeviceName: '',
        Gpnos: '',
        vDeviceIds: '',
        Type: ''
      });

      if (res.StatusCode !== this.$store.state.rightStatusCode) {
        alerterror(this, res.StatusCode);
        return null;
      }

      return res.Result || [];
    },

    async startOta() {
      try {
        if (this.otaStatus === OTA_STATUS_ENUMS.PROCESSING) return;

        this.otaSuccessHandled = false;
        this.otaStopHandled = false;
        this.clearRemoveSocketTimer();
        this.isLoadingReqOta = true;

        const otaDeviceList = await this.findAllUpgradeDevices();

        if (!otaDeviceList) {
          this.isLoadingReqOta = false;
          return;
        }

        const deviceOtaInfoMapping = this.buildDeviceOtaInfoMapping(otaDeviceList);
        const deviceIds = Object.keys(deviceOtaInfoMapping);

        if (!deviceIds.length) {
          warning(this, this.$t('otatask.warninginfor'));
          this.isLoadingReqOta = false;
          return;
        }

        const params = {
          isCombineOta: true,
          OtaMode: 0,
          DeviceOtaInfoMapping: deviceOtaInfoMapping
        };

        // 单升（一级设备 / 非 SigMesh）传 GpNo = 0；合并升不传
        if (!this.shouldCombineUpgrade()) {
          params.GpNo = 0;
        }

        const res = await BatchStartCombineOta(params);

        if (res.StatusCode !== this.$store.state.rightStatusCode) {
          alerterror(this, res.StatusCode);
          this.isLoadingReqOta = false;
          return;
        }

        const resultList = res.Result || [];
        const failedItems = resultList.filter(item =>
          item.StatusCode !== this.$store.state.rightStatusCode
        );

        if (failedItems.length && failedItems.length === resultList.length) {
          alerterror(this, failedItems[0].StatusCode);
          this.isLoadingReqOta = false;
          return;
        }

        if (failedItems.length) {
          const failMessage = failedItems
            .map(item => item.Message)
            .filter(Boolean)
            .join('; ');

          warning(this, failMessage || this.$t('deviceMsg.ingfail'));
        }

        setTimeout(() => {
          this.isLoadingReqOta = false;
        }, 20000);

        this.dosocketaction();
      } catch (err) {
        console.log(err);
        this.isLoadingReqOta = false;
      }
    },

    /* 注册socket信息
     */
     dosocketaction () {
      if(this.deviceModel.DeviceId === undefined) return;

      postWebIOSocket('sync_info_add_event', {
        data: [
          {
            projectCode: this.$store.state.projectcode,
            type: 6,
            id: this.deviceModel.DeviceId
          }
        ]
      })
    },

    async onRequestCancelOta() {
      this.otaStopHandled = false;
      this.isLoadingReqCancelOta = true;

      const res = await StopOta({ 
        childDeviceIds: this.deviceModel.VDeviceId 
      });

      this.isLoadingReqCancelOta = false;

      if (res.StatusCode == this.$store.state.rightStatusCode) {
        this.stopOta();
        this.isLoadingReqOta = false;
      } else {
        alerterror(this, res.StatusCode);
      }
    },
    
    /* 
     * 停止ota升级
     * 接口成功后先不立刻 removeSocket，等 OpCode 24/25 或超时再取消订阅，避免丢停止结果推送
     */
    stopOta () {
      this.setCurrentFirmware({
        otaStatus: OTA_STATUS_ENUMS.STOP,
        otaInfo: '', // this.$t('deviceMsg.upgrade'),
        progress: 0,
        hasError: false,
      });

      this.scheduleRemoveSocket();
    },

    clearRemoveSocketTimer() {
      if (this.removeSocketTimer) {
        clearTimeout(this.removeSocketTimer);
        this.removeSocketTimer = null;
      }
    },

    scheduleRemoveSocket(delay = 5000) {
      this.clearRemoveSocketTimer();
      this.removeSocketTimer = setTimeout(() => {
        this.removeSocketTimer = null;
        this.removeSocket();
      }, delay);
    },

     /* 移除单个socket信息
     */
     removeSocket() {
      this.clearRemoveSocketTimer();

      if (this.deviceModel.DeviceId === undefined) return;

      postWebIOSocket('sync_info_remove_event', {
        data: [
          {
            projectCode: this.$store.state.projectcode,
            type: 6,
            id: this.deviceModel.DeviceId
          }
        ]
      });
    },

    /**
     * 处理socket
     * @param res 
     */
    async handlerSocket(res) {
      // console.log(`[socket]`, res);
      if (res.StatusCode !== this.$store.state.rightStatusCode || !res.Result) return;

      const Result = res.Result[0];
      const Type = Result.Type;
      // 只处理当前设备
      if (this.deviceModel.DeviceId !== Result.DeviceId) return;

      if (Type === 6) {
        this.handlerOtaSocket(Result);
      }

      if (Type === 11) {
        // 升级过程离线
        this.handlerDeviceOnline(Result);
      }
    },

    setCurrentFirmware({ otaStatus, progress, otaInfo, hasError }) {
      this.otaStatus = otaStatus;
      this.progress = progress;
      this.otaInfo = otaInfo;
      this.hasError = hasError;
    },

    // ota升级信息
    async handlerOtaSocket(res) {
      const { MsgType } = res;
      const OpCode = Number(res.OpCode);
      const Progress = Number(res.Progress);
      
      console.log('更新进度', {
        OpCode,
        Progress,
        MsgType,
        Type: 6
      });

      // 正常情况
      if (OpCode === 0) {
        if (res.MsgType === '0x02660000') {
          // 界面点击取消 - 成功
          if (this.otaStopHandled) return;
          this.otaStopHandled = true;

          success(this, this.$t('deviceMsg.stopsuccess'));

          this.setCurrentFirmware({
            otaStatus: OTA_STATUS_ENUMS.PADDING,
            progress: 0,
            otaInfo: '',
            hasError: false,
          });

          this.removeSocket();
          return;
        }

        this.setCurrentFirmware({
          otaStatus: OTA_STATUS_ENUMS.PROCESSING,
          progress: Progress,
          otaInfo: Progress > 0 ? this.$t('deviceMsg.upgrade') : this.$t('deviceMsg.issued'),
          hasError: false,
        });

         // 升级成功
        if (Progress === 100) {
          if (this.otaSuccessHandled) return;
          this.otaSuccessHandled = true;

          await sleep(1.5 * 1000);

          this.setCurrentFirmware({
            otaStatus: OTA_STATUS_ENUMS.SUCCESS,
            progress: 0,
            otaInfo: '',
            hasError: false,
          });

          this.$emit('otaSuccess');
        }
      }

      if (OpCode === 1) {
         // 0x020A0000 发起升级失败 0x02200000 升级中失败
        if (
          ['0x020A0000', '0x02200000'].includes(MsgType) &&
          this.otaStatus !== OTA_STATUS_ENUMS.STOP
        ) {
          this.setCurrentFirmware({
            otaStatus: OTA_STATUS_ENUMS.PADDING,
            otaInfo: this.$t('deviceMsg.ingfail'),
            hasError: true,
          });

          warning(this, this.$t('deviceMsg.ingfail'));
        }

        // 界面点击取消 - 失败，继续升级，保留订阅
        if (MsgType === '0x02660000') {
          this.clearRemoveSocketTimer();

          this.setCurrentFirmware({
            otaStatus: OTA_STATUS_ENUMS.PROCESSING,
            otaInfo: this.$t('deviceMsg.stopfail'),
            hasError: true,
          });

          warning(this, this.$t('deviceMsg.stopfail'))
        }        
      }

      const errorMsg = {
        4: this.$t('deviceMsg.UpgradeDuplicate'),
        21: this.$t('deviceMsg.UpgradeBusy'),
        22: this.$t('deviceMsg.UpgradeConfilct'),
        23: this.$t('deviceMsg.UpgradeProjectIdNull'),
        24: this.$t('deviceMsg.stopsuccess'),
        25: this.$t('deviceMsg.stopfail'),
      }

      if (
        [4, 21, 22, 23].includes(OpCode) && 
        this.otaStatus !== OTA_STATUS_ENUMS.STOP
      ) {
        this.setCurrentFirmware({
          otaStatus: OTA_STATUS_ENUMS.PADDING,
          otaInfo: errorMsg[OpCode],
          hasError: true,
        });

        warning(this, errorMsg[OpCode]);
      }

      if (OpCode == 24) {
        if (this.otaStopHandled) return;
        this.otaStopHandled = true;

        this.setCurrentFirmware({
          otaStatus: OTA_STATUS_ENUMS.PADDING,
          otaInfo: errorMsg[OpCode],
          hasError: false,
        });

        success(this, errorMsg[OpCode]);
        this.removeSocket();
      }

      if (OpCode == 25) {
        // 停止失败，继续升级，保留订阅
        this.clearRemoveSocketTimer();

        this.setCurrentFirmware({
          otaStatus: OTA_STATUS_ENUMS.PROCESSING,
          otaInfo: errorMsg[OpCode],
          hasError: true,
        });

        warning(this, errorMsg[OpCode])
      }
    },

    /**
     * 升级至一半设备离线
     * @param res 
     */
    handlerDeviceOnline(res) {
      console.log('更新进度', {
        Type: 11
      });

      const VDeviceId = res.VDeviceId;

      // 同一个设备才处理
      if (Number(VDeviceId) !== Number(this.deviceModel.VDeviceId)) return;

      const isOnlineData = (res.StatusInfo || []).find(item => item.StatusType === '0x0100') || { Value: 1 };
      const isOnline = Number(isOnlineData.Value) === 1;
      console.log('isOnlineData', isOnlineData, isOnline)
      // 升级过程离线
      if (
        !isOnline && 
        // !this.isloadingota && !this.isstop
        this.otaStatus === OTA_STATUS_ENUMS.PROCESSING
      ) {
        error(this, this.$t('deviceMsg.ingfail'));

        this.setCurrentFirmware({
          otaStatus: OTA_STATUS_ENUMS.PADDING,
          // otaStatus: OTA_STATUS_ENUMS.UPDATE_FAILED,
          otaInfo: this.$t('deviceMsg.ingfail'),
          hasError: true,
        })
        // this.stopOta();
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.opple-ota-bind {
  width: 100%;
}

.opple-ota-cards_progress {
  display: flex;
  align-items: center;
  margin: 8px 0 12px;
  min-height: 25px;

  &_btn {
    margin-right: 15px;
  }

  &_info {
    margin-right: 5px;
  }
}

.opple-ota-bind_cards {
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  overflow-y: hidden;
  width: 100%;
  margin-bottom: 10px;
  -webkit-overflow-scrolling: touch;
}
</style>